import React from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, Box, Preloader, useResponsive } from '@common-fe/common-fe';

import { ModalWrapper } from '@/components/wrappers';

interface Props {
  icon?: React.ReactNode;
  title?: React.ReactNode | string;
  description?: React.ReactNode | string;
  form?: React.ReactNode;
  footerNode?: React.ReactNode;
  isLoading?: boolean;
  error?: React.ReactNode;
  testId?: string;
  onSetVisible: (value: boolean) => void;
  onConfirm: () => void;
  onBack?: () => void;
}

const VerificationCodeModal: React.FC<Props> = ({
  icon,
  title,
  description,
  form,
  footerNode,
  isLoading,
  error,
  testId,
  onSetVisible,
  onConfirm,
  onBack,
}) => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();

  return (
    <ModalWrapper visible onSetVisible={onSetVisible} testId={testId}>
      <Box margin={isMobile ? { top: 'spacing8' } : { top: 'spacing24' }} align="center">
        {icon}
        {title}
        {description}
      </Box>

      {form ? (
        <Box
          margin={isMobile ? { top: 'spacing16' } : { top: 'spacing24' }}
          background="module"
          pad={isMobile ? 'spacing8' : 'spacing24'}
          round="moduleRound"
        >
          <Box background="canvas" round="container1Round">
            {form}
          </Box>
        </Box>
      ) : null}

      <Box margin={isMobile ? { top: 'spacing16' } : { top: 'spacing24' }}>
        {error}
        <Box
          direction={isMobile ? 'column' : 'row'}
          justify={isMobile ? undefined : 'between'}
          align="center"
        >
          {footerNode}
          <Box
            direction={isMobile ? 'column-reverse' : 'row'}
            justify={isMobile ? undefined : 'end'}
            fill={isMobile}
            margin={isMobile ? {} : { left: 'auto' }}
            gap="spacing8"
          >
            {onBack && (
              <AppButton
                width={isMobile ? '100%' : '160px'}
                buttonType="secondary"
                testId={`${testId}_back`}
                onClick={onBack}
              >
                {t('Back')}
              </AppButton>
            )}

            <AppButton
              width={isMobile ? '100%' : '160px'}
              testId={`${testId}_confirm`}
              {...(isLoading ? {} : { onClick: onConfirm })}
            >
              {isLoading ? <Preloader /> : t('Confirm')}
            </AppButton>
          </Box>
        </Box>
      </Box>
    </ModalWrapper>
  );
};

export default VerificationCodeModal;
